import * as React from 'react'

import { FirstName, FormGroup, LastName } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { FormProps } from '../types'

const PickupName: React.FunctionComponent<FormProps> = () => {
  const { getLabel } = useIntl()
  return (
    <React.Fragment>
      <FormGroup columns={2}>
        <FirstName
          label={getLabel('checkout.contact.firstName')}
          errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
        />
        <LastName
          label={getLabel('checkout.contact.lastName')}
          errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
        />
      </FormGroup>
    </React.Fragment>
  )
}

export default PickupName
